import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import NavigationHeader from "../../../components/NavigationHeader";
import { Container } from "@mui/material";
import {
  Add as AddIcon,
  ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { RouteType } from "./types";
import { routeServiceApi } from "./apiService";
import { Loading } from "../../../components/Loading";
import DisplayStops from "./DisplayStops";
import ScheduleView from "./ScheduleView";
import AddScheduleModal from "./AddScheduleModal";
import { useNavigate } from "react-router-dom";
import { smallButtonProp } from "../../../utils/styles";

const RouteComponent = () => {
  const navigate = useNavigate();
  const [routes, setRoutes] = useState<RouteType[] | []>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [expandedPanel, setExpandedPanel] = useState<string | false>(false);
  const [addScheduleModalOpen, setAddScheduleModalOpen] =
    useState<boolean>(false);
  const [selectedRouteForSchedule, setSelectedRouteForSchedule] =
    useState<RouteType | null>(null);

  const fetchRoutes = async () => {
    setIsLoading(true);
    const routes = await routeServiceApi.getAllCompanyRoutes();
    setRoutes(routes);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchRoutes();
  }, []);

  const handleAddRoute = () => {
    navigate("/master-data/routes/add");
  };

  const handleAddSchedule = (route: RouteType) => {
    setSelectedRouteForSchedule(route);
    setAddScheduleModalOpen(true);
  };

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedPanel(isExpanded ? panel : false);
    };

  if (isLoading) {
    return <Loading message="Loading routes ..." fullScreen={true} />;
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <NavigationHeader
        breadcrumbs={[
          { label: "Master Data", path: "/master-data" },
          { label: "Routes" },
        ]}
        title="Routes"
        button={{
          label: "Add Route",
          onClick: handleAddRoute,
          icon: <AddIcon />,
        }}
      />

      {routes?.length <= 0 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Typography variant="body1" sx={{ textAlign: "center", mt: 4 }}>
            No Routes found
          </Typography>
        </Box>
      ) : (
        <Box>
          {routes.map((route: RouteType, index: number) => (
            <>
              <Accordion
                key={route?.id}
                expanded={expandedPanel === route?.id}
                onChange={handleAccordionChange(route?.id || "")}
                sx={{ mb: 1 }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 1,
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            flex: 1,
                            fontSize: "0.8rem",
                            minWidth: "150px",
                          }}
                        >
                          {route?.fromLocation} → {route?.toLocation}
                        </Typography>
                        {route?.routeName && (
                          <Chip
                            label={`${route?.routeName}`}
                            variant="outlined"
                            style={{ fontSize: "0.65rem", borderRadius: 5 }}
                            size="small"
                          />
                        )}
                        <Chip
                          label={`${route?.stops?.length} : Stops`}
                          variant="outlined"
                          style={{ fontSize: "0.65rem", borderRadius: 5 }}
                          size="small"
                        />
                        <Chip
                          label={`${route?.schedules?.length} : Schedules`}
                          variant="outlined"
                          style={{ fontSize: "0.65rem", borderRadius: 5 }}
                          size="small"
                        />
                        {route?.routeManagerName && (
                          <Typography sx={{ fontSize: "0.8rem", ml: 1 }}>
                            Manager : {route?.routeManagerName}
                            {route?.routeManagerNumber &&
                              ` - ${route?.routeManagerNumber}`}
                          </Typography>
                        )}
                      </Box>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button
                          variant="outlined"
                          color="primary"
                          {...smallButtonProp}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/master-data/routes/${route?.id}/edit`);
                          }}
                        >
                          Edit Route
                        </Button>
                        <Button
                          variant="outlined"
                          color="primary"
                          {...smallButtonProp}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAddSchedule(route);
                          }}
                        >
                          Add Schedule
                        </Button>
                      </Box>
                    </>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <DisplayStops stops={route.stops} /> */}
                  <ScheduleView
                    schedules={route?.schedules}
                    onSaveSchedule={fetchRoutes}
                  />
                </AccordionDetails>
              </Accordion>
            </>
          ))}
        </Box>
      )}

      <AddScheduleModal
        open={addScheduleModalOpen}
        onClose={() => {
          setAddScheduleModalOpen(false);
          setSelectedRouteForSchedule(null);
        }}
        route={selectedRouteForSchedule}
        onSuccess={() => fetchRoutes()}
      />
    </Container>
  );
};

export default RouteComponent;
